import React, { useState } from 'react';
import { ListChecks } from 'lucide-react';
import TelnyxPhoneManagement from './TelnyxPhoneManagement';
import VonagePhoneManagement from './VonagePhoneManagement';
import TwilioPhoneManagement from './TwilioPhoneManagement';
import AllNumbersView from './AllNumbersView';

/**
 * PhoneNumbersHub
 *
 * Top-level "Phone Numbers" section that lets users switch between:
 *   - Numbers: consolidated view of every assigned number with provider
 *     badges (Telnyx / Vonage / Twilio).
 *   - Telnyx: buy / setup / manage Telnyx numbers.
 *   - Vonage: buy / setup / manage Vonage numbers.
 *   - Twilio: buy / setup / manage Twilio numbers.
 */
const PhoneNumbersHub = () => {
    const [view, setView] = useState('numbers');

    const pillClasses = (active) =>
        `flex items-center gap-2 px-5 py-2 rounded-lg text-sm font-medium transition-all duration-200 border ${
            active
                ? 'bg-gradient-button text-primary-foreground shadow-md border-transparent'
                : 'text-muted-foreground hover:text-foreground bg-card/60 hover:bg-card border-border/50 hover:border-border'
        }`;

    return (
        <div className="flex-1 flex flex-col min-h-0">
            <div className="flex items-center gap-3 mb-4 pb-4 border-b border-border/40 flex-wrap">
                <span className="text-sm font-medium text-muted-foreground mr-1">View:</span>

                <button
                    onClick={() => setView('numbers')}
                    className={pillClasses(view === 'numbers')}
                >
                    <ListChecks className="w-4 h-4" />
                    Numbers
                </button>

                <button
                    onClick={() => setView('telnyx')}
                    className={pillClasses(view === 'telnyx')}
                >
                    <span className="w-2 h-2 rounded-full bg-purple-400 flex-shrink-0" />
                    Telnyx
                </button>

                <button
                    onClick={() => setView('vonage')}
                    className={pillClasses(view === 'vonage')}
                >
                    <span className="w-2 h-2 rounded-full bg-orange-400 flex-shrink-0" />
                    Vonage
                </button>

                <button
                    onClick={() => setView('twilio')}
                    className={pillClasses(view === 'twilio')}
                >
                    <span className="w-2 h-2 rounded-full bg-blue-400 flex-shrink-0" />
                    Twilio
                </button>
            </div>

            {view === 'numbers' && <AllNumbersView />}
            {view === 'telnyx' && <TelnyxPhoneManagement />}
            {view === 'vonage' && <VonagePhoneManagement />}
            {view === 'twilio' && <TwilioPhoneManagement />}
        </div>
    );
};

export default PhoneNumbersHub;
